import React, {useEffect, useMemo} from "react";
import Styles from './styles.module.scss'

import Seo from "../../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import CabinetHello from "../../../components/_UI/cabinetHello";
import CabinetCapsuleMain from "../../../components/cabinet/cabinetCapsuleMain";
import CabinetCapsuleQuestionnaire from "../../../components/cabinet/cabinetCapsuleQuestionnaire";
import CabinetCapsuleMaterials from "../../../components/cabinet/cabinetCapsuleMaterials";
import CabinetCapsuleNotes from "../../../components/cabinet/cabinetCapsuleNotes";
import CabinetCapsuleQuestionnaireModal from "../../../components/cabinet/cabinetCapsuleQuestionnaireModal";
import CabinetCapsuleNotesModal from "../../../components/cabinet/cabinetCapsuleNotesModal";
import CabinetCapsuleFilesModal from "../../../components/cabinet/cabinetCapsuleFilesModal";
import CabinetCapsuleBuyModal from "../../../components/cabinet/cabinetCapsuleBuyModal";
import CabinetCapsuleSealModal from "../../../components/cabinet/cabinetCapsuleSealModal";
import CabinetCapsuleStorageModal from "../../../components/cabinet/cabinetCapsuleStorageModal";

import {getCapsuleStats, getPreSaleMain} from "../../../store/cabinet/action";
import {capsulePercentHandler, isCapsuleLocked} from "../../../helpers/capsule";

const CabinetCapsulePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const capsuleStats = useSelector(store => store.cabinet.capsuleStats);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        if (authStatus){
            dispatch(getCapsuleStats());
            // тикер токена для модалки покупки
            dispatch(getPreSaleMain());
        }
    },[authStatus, dispatch])

    const percent = capsulePercentHandler(capsuleStats?.stats);
    // пока капсула не куплена, активна только покупка
    const isLocked = isCapsuleLocked(capsuleStats?.capsule_status);

    // одна и та же подпись: на мобильном — над карточками, на десктопе —
    // по центру под капсулой
    const status = useMemo(()=>{
        if (isLocked){
            return {
                title: t('Добро пожаловать в вашу капсулу'),
                description: t('Будущее начинается с того, что ты оставишь после себя.')
            };
        }
        if (percent >= 100){
            return {
                title: `${t('Капсула заполнена на')} 100%`,
                description: t('Все разделы готовы — можно переходить к созданию аватара')
            };
        }
        return {
            title: t('Добро пожаловать в вашу капсулу'),
            description: t('Заполните анкету, добавьте памятные материалы и заметки — так формируется ваша модель')
        };
    }, [isLocked, percent, t])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Моя капсула')}/>
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.colCenter}`}>
                    <div className={`${Styles.helloWrap} ${Styles.cabinetPC}`}>
                        <CabinetHello
                            title={status.title}
                            description={status.description}
                        />
                    </div>
                </div>
                <div className={`${Styles.colLeft}`}>
                    <CabinetCapsuleMain/>
                </div>
                <div className={`${Styles.colRight}`}>
                    <CabinetCapsuleQuestionnaire/>
                    <CabinetCapsuleMaterials/>
                    <CabinetCapsuleNotes/>
                </div>
            </div>

            {/* модалка покупки живёт всегда: после оплаты капсула перестаёт быть
                закрытой, а чек должен остаться на экране до закрытия */}
            <CabinetCapsuleBuyModal/>
            <CabinetCapsuleSealModal/>

            {/* разделы капсулы недоступны, пока она не куплена */}
            {!isLocked ? (
                <>
                    <CabinetCapsuleQuestionnaireModal/>
                    <CabinetCapsuleNotesModal/>
                    <CabinetCapsuleFilesModal/>
                    <CabinetCapsuleStorageModal/>
                </>
            ) : null}
        </section>
    );
};

export default CabinetCapsulePage;
